import { Divider, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import FinanciarFunctions from './FinanciarFunctions';


export default class AnalizaVanzarilorAditionale extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }


    analizaInterpretare = (a) => {


        if (a < 1) {
            return 'Instabila'
        } else if (a > 1 && a < 15) {
            return 'Stabila'
        } else {
            return 'Volatila'
        }

    }

    analizaInterpretareColor = (a) => {


        if (a < 1) {
            return 'rgb(227, 51, 59)'
        } else if (a > 1 && a < 15) {
            return 'rgb(229 178 58)'
        } else {
            return 'rgb(85 133 27)'
        }

    }

    f = new FinanciarFunctions()
    render() {
        return (
            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.analizaVanzarilorAditionale} </h5>

                    <Divider className='pm-divider' />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid container>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.rataProfituluiBrut} </h5>
                        </Grid>

                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.marjaNetaAProfitului} </h5>
                        </Grid>
                    </Grid>


                    <Divider className='pm-divider' />
                </Grid>

                <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid container>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <Grid container>
                                <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
                                    <Grid style={{ textAlign: 'left' }} container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.rataProfituluiBrut}</span>
                                        </Grid>
                                        <Grid style={{ marginTop: 10 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <span style={{ marginRight: 20, fontSize: 20, display: 'block', fontWeight: 600, color: 'black', }}>{this.f.rataProfituluiBrut(this.props.bilanturiDesc[0])}%  </span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                    <Grid style={{ textAlign: 'left' }} container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.analiza}</span>
                                        </Grid>
                                        <Grid style={{ marginTop: 10 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: this.analizaInterpretareColor(this.f.rataProfituluiBrut(this.props.bilanturiDesc[0])) }}>{this.analizaInterpretare(this.f.rataProfituluiBrut(this.props.bilanturiDesc[0]))} </span>
                                        </Grid>
                                    </Grid>

                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <Grid container>
                                <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
                                    <Grid style={{ textAlign: 'left' }} container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.marjaNetaAProfitului}</span>
                                        </Grid>
                                        <Grid style={{ marginTop: 10 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <span style={{ marginRight: 20, fontSize: 20, display: 'block', fontWeight: 600, color: 'black', }}>{this.f.marjaNetaAProfitului(this.props.bilanturiDesc[0])}%  </span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                    <Grid style={{ textAlign: 'left' }} container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.analiza}</span>
                                        </Grid>
                                        <Grid style={{ marginTop: 10 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                            <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: this.analizaInterpretareColor(this.f.rataProfituluiBrut(this.props.bilanturiDesc[0])) }}>{this.analizaInterpretare(this.f.rataProfituluiBrut(this.props.bilanturiDesc[0]))} </span>
                                        </Grid>
                                    </Grid>

                                </Grid>

                            </Grid>
                        </Grid>


                    </Grid>


                    <Divider style={{ marginTop: 20 }} className='pm-divider' />
                </Grid>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid container>
                        <Grid style={{ textAlign: 'left', paddingRight:10 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <span style={{ fontSize: 12 }}> {this.dictionary.financiar.rataProfituluiBrutText}</span>


                        </Grid>
                        <Grid style={{ textAlign: 'left' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <span style={{ fontSize: 12 }}> {this.dictionary.financiar.marjaProfituluiBrutText}</span>


                        </Grid>

                    </Grid>
                </Grid>




            </Grid>
        );
    }
}